import { render, staticRenderFns } from "./ManageServiceCost.vue?vue&type=template&id=838fb11e&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./ManageServiceCost.vue?vue&type=style&index=0&id=838fb11e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838fb11e",
  null
  
)

export default component.exports